<div>
  <h1 class="header col-12 mb-2">
    Annuity Book Management <span>- Office View</span>
  </h1>

  <app-bm-widget-filters
    [viewMode]="'ho'"
    [preexistingWidgetFilters]="preexistingWidgetFilters"
  />

  <div class="home-office-container">
    <div class="row">
      <app-contract-stats
        class="col-12"
        [reportName]="'PM Unit Contract Totals'"
      />
    </div>

    @if (rights.includes('PMOfficePolicyDrilldown')) {
      <div class="row">
        <app-policy-drilldown
          class="col-12"
          [view]="'ho'"
          (emitDrilldownFilter)="emitDrilldownFilter($event)"
        />
      </div>
    }
    @if (rights.includes('PMOfficePolicySummaryGroupBy')) {
      <div class="row">
        <app-contract-summary
          class="col-12"
          [reportName]="'PM Unit Contract Summary'"
          [headerType]="'unit'"
        />
      </div>
    }

    <div class="row">
      <app-top-performers
        class="col-12"
        [title]="'Top Performers'"
        [configType]="'unit-top-performers'"
        [reportName]="'PM Unit Top Performers'"
      />
    </div>

    <div class="row">
      @if (showPolicyTags) {
        <app-policy-alerts
          [ngClass]="{ 'col-6': showPolicyReview }"
          [configType]="'unit-policy-alerts'"
          [reportName]="'PM Unit Policy Alerts'"
          [headerType]="'unit'"
        />
      }
      @if (showPolicyReview) {
        <app-top-policy-review
          [ngClass]="{ 'col-6': showPolicyTags }"
          [title]="'Policy Review Relevance'"
          [configType]="'unit-top-policy-review'"
          [reportName]="'PM Unit Top Policy Review'"
        />
      }
    </div>
  </div>
</div>
